<template>
<div class="animated fadeIn">
  <b-card>
    <div slot="header">
      <strong>Distribuição</strong>
    </div>
    <h3>Geral</h3>
    <b-row class="mb-3">
      <b-col >
        <b-button :disabled="working" @click="action(10)" variant="primary">Calcular Ranking</b-button>
        <p class="help-block">Calcula o ranking dos inscritos para a distribuição</p>
      </b-col>
      <b-col >
        <b-button :disabled="working"  @click="action(20)"  variant="primary">Bloquear colocados</b-button>
        <p class="help-block">Bloqueia os inscritos que ficaram colocados num campo.</p>
      </b-col>
      <b-col >
        <b-button :disabled="working"  @click="action(30)"  variant="primary">Desbloquear colocados</b-button>
        <p class="help-block">Desbloqueia os inscritos que estão bloqueados.</p>
      </b-col>
      <b-col >
        <b-button :disabled="working"  @click="action(40)"  variant="primary">Reiniciar distribuição</b-button>
        <p class="help-block">Coloca as inscrições que não estão bloqueadas no seu estado inicial.</p>
      </b-col>
      <b-col >
        <b-button :disabled="working"  @click="action(41)"  variant="primary">Marcar Lista de Espera</b-button>
        <p class="help-block">Coloca as inscriçoes que não tenham sido atribuídas a um campo na lista de espera</p>
      </b-col>
    </b-row>

    <h3>Distribuir</h3>
    <b-row class="mb-3">
    <b-col >
      <b-button :disabled="working" @click="customDist()" variant="primary">Distribuir</b-button>
      <p class="help-block">Distribuição costumizada</p>
    </b-col>
      <b-col >
        <b-button :disabled="working" @click="action(2)" variant="primary">M/F</b-button>
        <p class="help-block">Distribui utilizando apenas os limites M/F</p>
      </b-col>
      <b-col >
        <b-button :disabled="working" @click="action(50)" variant="primary"><i class="fa fa-undo"></i> UNDO</b-button>
        <p class="help-block">Desfazer última ação</p>
      </b-col>
      <b-col >
        <b-button :disabled="working" @click="action(60)" variant="primary"><i class="fa fa-repeat"></i> REDO</b-button>
        <p class="help-block">Refazer última ação</p>
      </b-col>
    </b-row>

    <h3>Enviar emails</h3>
    <b-row class="mb-3">
      <b-col >
        <b-button :disabled="working" @click="sendEmails()" variant="primary">Enviar emails</b-button>
        <p class="help-block">Enviar emails com resultado da distribuição</p>
      </b-col>
    </b-row>
  </b-card>

  <loading v-if="loadingResults || working"></loading>
  <div  v-if="!loadingResults && !working" >
    <b-card title="Vagas por preencher">
      <b-row>
        <b-col :key="item.id" v-for="item in results">
          <span>{{ item.name }}</span><br>
          <strong >{{ item.vacancies }}</strong>
        </b-col>
      </b-row>
    </b-card>
    <b-card :key="item.id" v-for="item in results" :title="item.name">
      <div class="mb-5" >
        <p>
          <b-button size="sm" variant="success" class="text-white" :disabled="exporting" v-on:click="exportRegistrations(item.id, 0)"><i v-show="!exporting" class="fa fa-download"></i><i v-show="exporting" class="fa fa-spinner fa-spin"></i> Exportar</b-button>
          <b-button size="sm" variant="success" class="text-white" :disabled="exporting" v-on:click="exportRegistrations(item.id, 0, 1)"><i v-show="!exporting" class="fa fa-download"></i><i v-show="exporting" class="fa fa-spinner fa-spin"></i> Exportar fila de espera</b-button>
        </p>
        <b-row class="mb-3">
          <b-col md="3">
            <table class="table table-stripped">
              <thead>
                <tr>
                  <th>Geral</th>
                  <th>Total</th>
                  <th>M</th>
                  <th>F</th>
                </tr>
              </thead>
              <tr>
                <td>Total</td>
                <td>{{ item.total }}</td>
                <td>{{ item.boys + item.onhold_boys }}</td>
                <td>{{ item.girls + item.onhold_girls }}</td>
              </tr>
              <tr>
                <td>Colocados</td>
                <td>{{ item.assigned }}</td>
                <td>{{ item.boys }}</td>
                <td>{{ item.girls }}</td>
              </tr>
              <tr>
                <td>Lista de espera</td>
                <td>{{ item.onhold }}</td>
                <td>{{ item.onhold_boys }}</td>
                <td>{{ item.onhold_girls }}</td>
              </tr>
              <tr>
                <td>Bloqueados</td>
                <td>{{ item.distribution_locked }}</td>
                <td></td>
                <td></td>
              </tr>
            </table>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" :key="sub.id" v-for="sub in item.subactivities" >
            <h6>{{ sub.name }} <b-button variant="success" class="text-white btn-sm" :disabled="exporting" v-on:click="exportRegistrations(item.id, sub.id)"><i v-show="!exporting" class="fa fa-download"></i><i v-show="exporting" class="fa fa-spinner fa-spin"></i> Exportar</b-button></h6>
            <b-row>
              <b-col>
                Total:
              </b-col>
              <b-col class="text-right">
                {{ sub.total }} / {{ sub.max }}
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                M:
              </b-col>
              <b-col class="text-right">
                {{ sub.boys }} / {{ sub.max_boys }}
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                F:
              </b-col>
              <b-col class="text-right">
                {{ sub.girls }} / {{ sub.max_girls }}
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                Veteranos:
              </b-col>
              <b-col class="text-right">
                {{ sub.veterans }} / {{ sub.max_veterans }}
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                Caloiros:
              </b-col>
              <b-col class="text-right">
                {{ sub.newones }} / {{ sub.max_new }}
              </b-col>
            </b-row>
            <activity-table :showlimits="true" :item="sub"></activity-table>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6"  >

          <h6>Lista de espera <b-button variant="success" class="text-white btn-sm" :disabled="exporting" v-on:click="exportRegistrations(item.id, 0, 1)"><i v-show="!exporting" class="fa fa-download"></i><i v-show="exporting" class="fa fa-spinner fa-spin"></i> Exportar</b-button></h6>
          <b-row>
            <b-col>
              Total:
            </b-col>
            <b-col class="text-right">
              {{ item.onhold_details.total }}
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              M:
            </b-col>
            <b-col class="text-right">
              {{ item.onhold_details.boys }}
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              F:
            </b-col>
            <b-col class="text-right">
              {{ item.onhold_details.girls }}
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              Veteranos:
            </b-col>
            <b-col class="text-right">
              {{ item.onhold_details.veterans }}
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              Caloiros:
            </b-col>
            <b-col class="text-right">
              {{ item.onhold_details.newones }}
            </b-col>
          </b-row>
          <activity-table :showlimits="false" :item="item.onhold_details"></activity-table>
          </b-col>
          </b-row>
      </div>
    </b-card>
  </div>

  <b-modal id="confirm-action" hide-footer>
    <template v-slot:modal-title>
      {{ actionLabel }}
    </template>
    <div class="d-block text-center">
      {{ actionDesc }}
    </div>
    <b-button class="mt-3" @click="$bvModal.hide('confirm-action')">Cancelar</b-button>
    <b-button variant="success" class="mt-3 pull-right" @click="doAction()">Continuar</b-button>
  </b-modal>
  <b-modal id="custom-distribution" size="xl" hide-footer>
    <template v-slot:modal-title>
      Distribuição costumizada
    </template>
    <div class="d-block ">
      <p>Distribuir apenas inscritos de:</p>
      <b-row>
        <b-col md="3">
          <b-form-fieldset label="Actividade">
            <b-form-select v-model="customDistData.activity_id" :options="activities" class="mb-3">
              <template v-slot:first>
                <b-form-select-option :value="null">Todas</b-form-select-option>
              </template>
            </b-form-select>
          </b-form-fieldset>

          <b-form-group label="Campos">
            <b-form-checkbox-group
                v-model="customDistData.subactivities"
                :options="filteredSubs"
                class="mb-3"
                value-field="id"
                text-field="name"
                stacked
              ></b-form-checkbox-group>
          </b-form-group>

        </b-col>
        <b-col md="3">
          <b-form-group label="Regiões">
            <b-form-checkbox-group
                v-model="customDistData.regions"
                :options="regions"
                class="mb-3"
                value-field="id"
                text-field="name"
                stacked
              ></b-form-checkbox-group>
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-fieldset label="Caloiros/Veteranos">
            <b-form-select v-model="customDistData.registrations_veterans" class="mb-3">
              <b-form-select-option :value="null">Todos</b-form-select-option>
              <b-form-select-option :value="1">Veteranos</b-form-select-option>
              <b-form-select-option :value="2">Caloiros</b-form-select-option>
            </b-form-select>
          </b-form-fieldset>
        </b-col>
        <b-col md="3">
          <b-form-fieldset label="Penalizados">
            <b-form-select v-model="customDistData.registrations_penalties" class="mb-3">
              <b-form-select-option :value="0">Não penalizados</b-form-select-option>
              <b-form-select-option :value="1">Todos</b-form-select-option>
            </b-form-select>
          </b-form-fieldset>
        </b-col>
      </b-row>
      <p>Utilizar os limites:</p>
      <b-row>
        <b-col md="4">
          <b-form-fieldset label="Nº Vagas" description="número de vagas a preencher. 0 para distribuir todas as vagas possíveis">
            <b-form-input type="number" min="0" name="family_member_nif" v-model="customDistData.slots" placeholder="Nº Vagas"   ></b-form-input>
          </b-form-fieldset>
        </b-col>
        <b-col md="4">
          <b-form-fieldset label="Sexo">
            <b-form-select v-model="customDistData.mf" class="mb-3">
              <option value="0">Inactivo</option>
              <option value="1">Activo</option>
            </b-form-select>
            <div slot="description" >Limite de rapazes / raparigas.</div>
          </b-form-fieldset>
        </b-col>
        <b-col md="4">
          <b-form-fieldset label="Veteranos / Novos">
            <b-form-select v-model="customDistData.veteran" class="mb-3">
              <option value="0">Inactivo</option>
              <option value="1">Activo</option>
            </b-form-select>
            <div slot="description" >Utilizar limites de veteranos / novos.</div>
          </b-form-fieldset>
        </b-col>
        <b-col md="4">
          <b-form-fieldset label="Regiões">
            <b-form-select v-model="customDistData.region" class="mb-3">
              <option value="0">Inactivo</option>
              <option value="1">Activo</option>
            </b-form-select>
            <div slot="description" >Utilizar limites de região, e respectivos mínimos.</div>
          </b-form-fieldset>
        </b-col>
        <b-col md="4">
          <b-form-fieldset label="Min Regiões">
            <b-form-select v-model="customDistData.min_region" class="mb-3">
              <option value="0">Inactivo</option>
              <option value="1">Activo</option>
            </b-form-select>
            <div slot="description" >Utilizar minimos de região.</div>
          </b-form-fieldset>
        </b-col>
      </b-row>
    </div>
    <b-button class="mt-3" @click="$bvModal.hide('custom-distribution')">Cancelar</b-button>
    <b-button variant="success" class="mt-3 pull-right" @click="doCustomDist()">Continuar</b-button>
  </b-modal>
  <b-modal id="send-emails"  hide-footer>
    <template v-slot:modal-title>
      Enviar emails
    </template>
    <div class="d-block ">
      <p>Enviar apenas para:</p>
      <b-row>
        <b-col md="6">
          <b-form-fieldset label="Actividade">
            <b-form-select v-model="sendEmailsData.activity_id" :options="activities" class="mb-3">
              <template v-slot:first>
                <b-form-select-option :value="null">Todas</b-form-select-option>
              </template>
            </b-form-select>
          </b-form-fieldset>

          <b-form-group label="Campos">
            <b-form-checkbox-group
                v-model="sendEmailsData.subactivities"
                :options="filteredSubsForEmail"
                class="mb-3"
                value-field="id"
                text-field="name"
                stacked
              ></b-form-checkbox-group>
          </b-form-group>

        </b-col>
        <b-col md="6">
          <b-form-fieldset label="Estado">
            <b-form-select v-model="sendEmailsData.state" class="mb-3">
              <b-form-select-option :value="0">Todos</b-form-select-option>
              <b-form-select-option :value="1">Colocados</b-form-select-option>
              <b-form-select-option :value="2">Em espera</b-form-select-option>
            </b-form-select>
          </b-form-fieldset>
        </b-col>
      </b-row>

      <b-form-fieldset label="ID Família" description="Enviar apenas para a família com id">
        <b-form-input type="number" min="0" name="family_member_nif" v-model="sendEmailsData.custom_id" placeholder="ID Família"   ></b-form-input>
      </b-form-fieldset>
    </div>
    <b-button class="mt-3" @click="$bvModal.hide('send-emails')">Cancelar</b-button>
    <b-button variant="success" class="mt-3 pull-right" @click="doSendEmails()">Continuar</b-button>
  </b-modal>
  <b-modal ref="downloadModal" id="downloadModal">
    O ficheiro está pronto:
    <a :href="fileDownload.url" target="_blank">{{ fileDownload.title }}</a>
    <div slot="modal-footer" class="w-100">
      <b-btn size="sm" class="float-right" variant="primary" @click="$bvModal.hide('downloadModal')">
        Close
      </b-btn>
    </div>
  </b-modal>
</div>
</template>

<script>
import ActivityTable from './table.vue'
export default {
  name: 'Distribution',
  components: {ActivityTable},
  props: [],
  data() {
    return {
      working: false,
      exporting: false,
      actionType: 1,
      fileDownload: {
        url: '',
        title: ''
      },
      activities: [],
      subactivities: [],
      regions: [],
      loadingResults: false,
      results: [],
      sendEmailsData: {
        activity_id: null,
        subactivities: [],
        state: 0,
        custom_id: '',
      },
      customDistData: {
        slots: 0,
        subactivities: [],
        mf: 1,
        veteran: 1,
        region: 1,
        min_region: 1,
        registrations_veterans: null,
        registrations_penalties: 0,
        activity_id: null,
        regions: []
      }
    }
  },
  computed: {
    actionLabel() {
      switch(this.actionType) {
        case 1:
        case 2:
          return 'Distribuição'
        case 10:
          return 'Ranking'
        case 20:
          return 'Bloquear'
        case 30:
          return 'Desbloquear'
        case 40:
          return 'Reiniciar'
        case 41:
          return 'Marcar lista de espera'
        case 50:
          return 'Undo'
        case 60:
          return 'Redo'

      }
      return ''
    },
    actionDesc() {
      switch(this.actionType) {
        case 1:
          return 'As inscrições vão ser distribuidas pelos campos.'
        case 2:
          return 'As inscrições vão ser distribuidas pelos campos utilizando apenas as restrições M/F.'
        case 10:
          return 'Vai ser calculado a pontuação das inscrições'
        case 20:
          return 'As inscrições colocadas em campos serão bloqueadas e o histórico de ações (undo/redo) será apagado.'
        case 30:
          return 'As inscrições bloqueadas serão desbloqueadas'
        case 40:
          return 'As inscrições desbloqueadas serão reiniciadas'
        case 41:
          return 'As inscrições que não ficaram atribuídas a um campo serão colocadas na lista de espera'
        case 50:
          return 'Última ação será desfeita'
        case 60:
          return 'Última ação será refeita'

      }
      return ''
    },
    filteredSubs() {
      return this.subactivities.filter(subactivity => subactivity.parent_id === this.customDistData.activity_id);
    },
    filteredSubsForEmail() {
      return this.subactivities.filter(subactivity => subactivity.parent_id === this.sendEmailsData.activity_id);
    }
  },
  methods: {
    action(action) {
      this.actionType = action
      this.$bvModal.show('confirm-action')
    },
    distribute() {
      this.actionType = 1
      this.$bvModal.show('confirm-action')
    },
    distributeMF() {
      this.actionType = 2
      this.$bvModal.show('confirm-action')
    },
    customDist() {
      this.$bvModal.show('custom-distribution')
    },
    sendEmails() {
      this.$bvModal.show('send-emails')
    },
    ranking() {
      this.$bvModal.hide('confirm-action')
      this.working = true
      this.axios.get('registrations/ranking').then(response => {
        console.log('ranking finished')
        this.working = false
        this.$bvToast.toast('Ranking concluído com sucesso', { autoHideDelay: 5000, variant: 'success', solid: true})
      }).catch(error => {
        this.$bvToast.toast('Houve um erro ao criar o ranking', { autoHideDelay: 5000, variant: 'danger', solid: true})
      })
    },
    lock() {
      this.$bvModal.hide('confirm-action')
      this.working = true
      this.axios.get('distribution/lock').then(response => {
        console.log('lock finished')
        this.working = false
        this.loadResults()
        this.$bvToast.toast('As inscrições colocadas foram bloqueadas', { autoHideDelay: 5000, variant: 'success', solid: true})
      }).catch(error => {
        this.$bvToast.toast('Houve um erro ao bloquear as inscrições', { autoHideDelay: 5000, variant: 'danger', solid: true})
      })
    },
    unlock() {
      this.$bvModal.hide('confirm-action')
      this.working = true
      this.axios.get('distribution/unlock').then(response => {
        console.log('unlock finished')
        this.working = false
        this.loadResults()
        this.$bvToast.toast('As inscrições colocadas foram desbloqueadas', { autoHideDelay: 5000, variant: 'success', solid: true})
      }).catch(error => {
        this.$bvToast.toast('Houve um erro ao desbloquear as inscrições', { autoHideDelay: 5000, variant: 'danger', solid: true})
      })
    },
    reset() {
      this.$bvModal.hide('confirm-action')
      this.working = true
      this.axios.get('distribution/reset').then(response => {
        console.log('reset finished')
        this.working = false
        this.loadResults()
        this.$bvToast.toast('Distribuição reiniciada', { autoHideDelay: 5000, variant: 'success', solid: true})
      }).catch(error => {
        this.$bvToast.toast('Houve um erro reiniciar as inscriçoes', { autoHideDelay: 5000, variant: 'danger', solid: true})
      })
    },
    onhold() {
      this.$bvModal.hide('confirm-action')
      this.working = true
      this.axios.get('distribution/mark_onhold').then(response => {
        console.log('mark_onhold finished')
        this.working = false
        this.loadResults()
        this.$bvToast.toast('Inscrições colocadas em lista de espera', { autoHideDelay: 5000, variant: 'success', solid: true})
      }).catch(error => {
        this.$bvToast.toast('Houve um erro colocadar em lista de espera', { autoHideDelay: 5000, variant: 'danger', solid: true})
      })
    },
    undo() {
      this.$bvModal.hide('confirm-action')
      this.working = true
      this.axios.get('distribution/undo').then(response => {
        console.log('undo finished')
        this.working = false
        this.loadResults()
        this.$bvToast.toast('undo', { autoHideDelay: 5000, variant: 'success', solid: true})
      }).catch(error => {
        this.$bvToast.toast('Houve um erro reiniciar as inscriçoes', { autoHideDelay: 5000, variant: 'danger', solid: true})
      })
    },
    redo() {
      this.$bvModal.hide('confirm-action')
      this.working = true
      this.axios.get('distribution/redo').then(response => {
        console.log('redo finished')
        this.working = false
        this.loadResults()
        this.$bvToast.toast('redo', { autoHideDelay: 5000, variant: 'success', solid: true})
      }).catch(error => {
        this.$bvToast.toast('Houve um erro reiniciar as inscriçoes', { autoHideDelay: 5000, variant: 'danger', solid: true})
      })
    },
    doAction() {
      switch(this.actionType) {
        case 1:
        case 2:
          this.doDistribution()
          break
        case 10:
          this.ranking()
          break
        case 20:
          this.lock()
          break
        case 30:
          this.unlock()
          break
        case 40:
          this.reset()
          break
        case 41:
          this.onhold()
          break
        case 50:
          this.undo()
          break
        case 60:
          this.redo()
          break
      }
    },
    doDistribution() {
      let data = {}
      if (this.actionType == 1) {
        data = {}
      } else if (this.actionType == 2) {
        data = {
          mf: 1,
          activity_id: null,
          veteran: 0,
          region: 0
        }
      }
      this.working = true
      this.$bvModal.hide('confirm-action')
      this.axios.post('distribution/distribute', data).then(response => {
        console.log('finished')
        this.working = false
        this.loadResults()
        this.$bvToast.toast('As inscrições colocadas foram distribuídas', { autoHideDelay: 5000, variant: 'success', solid: true})
      }).catch(error => {
        this.$bvToast.toast('Houve um erro ao distribuír as inscrições', { autoHideDelay: 5000, variant: 'danger', solid: true})
      })
    },
    doCustomDist() {
      this.working = true
      this.$bvModal.hide('custom-distribution')
      this.axios.post('distribution/distribute', this.customDistData).then(response => {
        console.log('finished')
        this.working = false
        this.loadResults()
        this.$bvToast.toast('As inscrições colocadas foram distribuídas', { autoHideDelay: 5000, variant: 'success', solid: true})
      }).catch(error => {
        this.$bvToast.toast('Houve um erro ao distribuír as inscrições', { autoHideDelay: 5000, variant: 'danger', solid: true})
      })
    },
    doSendEmails() {
      this.working = true
      this.$bvModal.hide('send-emails')
      this.axios.post('distribution/sendEmails', this.sendEmailsData).then(response => {
        console.log('finished')
        this.working = false
        this.$bvToast.toast('Foram enviados os emails para as inscrições', { autoHideDelay: 5000, variant: 'success', solid: true})
      }).catch(error => {
        this.$bvToast.toast('Houve um erro ao enviar os emails', { autoHideDelay: 5000, variant: 'danger', solid: true})
      })
    },
    loadResults() {
      this.loadingResults = true
      this.axios.get('distribution/results').then(response => {
        this.results = response.data.data
        this.loadingResults = false
      })
    },
    exportRegistrations(activity_id, subactivity_id, onhold) {

      let filters = {
        filter: {
          filters: [],
          logic: "and"
        }
      }
      if(activity_id) {
        filters.filter.filters.push({
          "field":"activity_id",
          "operator":"eq",
          "value": activity_id
        })
      }
      if(subactivity_id) {
        filters.filter.filters.push({
          "field":"subactivity_id",
          "operator":"eq",
          "value": subactivity_id
        })
      }
      if(typeof onhold !== "undefined") {
        filters.filter.filters.push({
          "field":"onhold",
          "operator":"eq",
          "value": onhold
        })
      }
      this.exporting = true
      this.axios.post('registrations/export', filters).then(response => {
        this.fileDownload = response.data
        this.$refs.downloadModal.show()
        this.exporting = false
      }).catch(error => {
        this.$bvToast.toast('Houve um erro a exportar', { autoHideDelay: 5000, variant: 'danger', solid: true})
        this.exporting = false
      })
    }
  },
  created() {
    this.loadResults()
    this.axios.get('activities/lst').then(response => {
      this.activities = response.data.data
    })
    this.axios.get('subactivities/lst').then(response => {
      this.subactivities = response.data.data
    })
    this.axios.get('regions/lst').then(response => {
      this.regions = response.data.data
      for(let i=0; i< this.regions.length; i++) {
        this.customDistData.regions.push(this.regions[i].id)
      }
    })
  }
}
</script>
